import useAPIv4 from './useAPIv4'

export default useAPIv4
